export function toBase64 (str) {
  if (typeof window !== 'undefined') {
    return window.btoa(str)
  }

  return Buffer.from(str).toString('base64')
}
